<template>
    <div id="warranty_view" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div class="web-right-sidebar">
            <div class="right-asset-tab-list">
                <ul class="activetabs" id="tabActive">
                    <li v-bind:class="[ activetab === 1 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="activetab=1" >Warranty Detail</a></li>
                    <li v-bind:class="[ activetab === 2 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="activetab=2">Asset Warranty</a></li>
                    <li v-bind:class="[ activetab === 3 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="activetab=3">Limitation</a></li>
                    <li v-bind:class="[ activetab === 4 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="getActivityLog()"> Activity Log </a> </li>
                </ul>
            </div>
        </div>
        <div id="page-content-wrapper" class="admin-content-area left-asset-detail-section">
            <template v-if="cantAccessPage === true">
                <div class="page-name asset-view-page-name">
                    <div class="page-title"> Warranty Details</div>
                    <div class="btn-groups text-right">
                        <button type="submit" v-if="activetab === 1 && canAddWarranty" class="btn btn-primary" v-on:click.prevent="updateWarranty" >
                            <i class="fp-edit-icon"> </i> Edit
                        </button>
                        <button type="submit" v-if="activetab === 2" class="btn btn-primary" v-on:click.prevent="addAsset">
                            <i class="fp-edit-icon"> </i> Edit
                        </button>
                        <button type="submit" v-if="activetab === 3" class="btn btn-primary" v-on:click.prevent="updateLimitation" >
                            <i class="fp-edit-icon"> </i> Edit Limitation
                        </button>
                        <button type="submit" class="btn btn-secondary" v-on:click.prevent="BackWarrantyList" >
                            <i class="fp-back"> </i>    Back
                        </button>
                    </div>
                </div>
                <div class="container-fluid">
                    <div id="customer-detail" class="admin-page-content insurance-policy-view list-view">
                        <section class="internal-container border-top-table-fl">
                            <div class="list-sections" v-if="activetab == 1">
                                <div class="form-row no-divider">
                                    <div class="col-md-6">
                                        <div class="row form-group">
                                            <label class="col">Code: </label>
                                            <span class="col"> {{warranty_code}} </span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Warranty Type: </label>
                                            <span class="col"> {{warranty_type}} </span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Period: </label>
                                            <span class="col"> {{period}} </span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Miles: </label>
                                            <span class="col"> {{miles}} </span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="row form-group">
                                            <label class="col">Description: </label>
                                            <span class="col"> {{warranty_desc}} </span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Starting Point Value: </label>
                                            <span class="col"> {{starting_point_value}} </span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Period Type: </label>
                                            <span class="col"> {{titleCase(period_type)}} </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="list-sections" v-if="activetab == 2">
                                <div class="purchase-order-create-main table-responsive-sm">
                                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col">#Unit</th>
                                                <th scope="col">Manufacturer</th>
                                                <th scope="col">Model</th>
                                                <th scope="col">Year</th>
                                                <th scope="col">Group</th>
                                                <th scope="col">Purchased</th>
                                                <th scope="col">In Service</th>
                                                <th scope="col">Warranty Applied</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="asset_warranty_arr != undefined && asset_warranty_arr.length > 0">
                                                <tr v-for="(asset, index1) in asset_warranty_arr" v-bind:key="index1">
                                                    <td>{{ asset.unit_no }}</td>
                                                    <td>{{ asset.manufacturer }}</td>
                                                    <td>{{ asset.model }}</td>
                                                    <td>{{ asset.year }}</td>
                                                    <td>{{ asset.group }}</td>
                                                    <td>{{ asset.purchased }}</td>
                                                    <td>{{ asset.in_service }}</td>
                                                    <td>{{ asset.status }}</td>
                                                </tr>
                                            </template>
                                            <template v-else>
                                                <tr>
                                                    <td colspan="8" style="text-align:center;">
                                                        No Data Found.
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="list-sections" v-if="activetab == 3">
                                <div class="purchase-order-create-main table-responsive-sm">
                                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col">Component</th>
                                                <th scope="col">Warranty Included/Excluded</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="warranty_limit_arr != undefined && warranty_limit_arr.length > 0">
                                                <tr v-for="(asset, index2) in warranty_limit_arr" v-bind:key="index2">
                                                    <td>{{ asset.item }}</td>
                                                    <td>{{ asset.is_applied }}</td>
                                                </tr>
                                            </template>
                                            <template v-else>
                                                <tr>
                                                    <td colspan="2" style="text-align:center;">
                                                        No Limitation Available.
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div id="warranty-activity-log" class="list-view" v-show="activetab == 4">
                                <div class="bg-white data-table p-0">
                                    <warranty-activity-log-list :activityLogVal="activityLogsTabValue"></warranty-activity-log-list>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';

import {contractMixins} from '../mixins/contractMixins';


export default {
    name: "WarrantyView",
    components: {
        WarrantyActivityLogList: () => import('@/components/ActivityLogList.vue'),
    },
    mixins:[commonMixins,contractMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: "",
        loading:false,
        activetab:1,
        canAddWarranty:false,
        warranty_code:"",
        warranty_desc:"",
        warranty_type:"",
        starting_point_value:"",
        miles:"",
        period:"",
        period_type:"",
        warranty_limit_arr:[],
        asset_warranty_arr:[],
        activityLogsTabValue:"dontLoadList",
        tabMenuArray:[],
        velocity_env:process.env.NODE_ENV,
    }),
    watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                  if(self.velocity_env == 'velev' || self.velocity_env == 'velev_test'){
                    if (permissions[i].name == 'ev_view_warranty') {
                        self.cantAccessPage = true;
                    }
                    if (permissions[i].name == 'ev_add_warranty') {
                        self.canAddWarranty = true;
                    }
                  }else{
                    if (permissions[i].name == 'view_warranty') {
                        self.cantAccessPage = true;
                    }
                    if (permissions[i].name == 'add_warranty') {
                        self.canAddWarranty = true;
                    }
                  }
                }
            }

        }
    },
    created: function() {

    },
    mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadWarrantyData();
    },
    metaInfo() {
        return {
            title: (this.warranty_code != "") ? this.warranty_code + " | Warranty View | " +process.env.COPYRIGHT_NAME:"Warranty View | " +process.env.COPYRIGHT_NAME
        }
    },
    methods: {
        BackWarrantyList() {
            var self = this;
            if (self.$route.query.wo != undefined){
                self.$router.push("/workorder/view/"+self.$route.query.wo);
            }else{
                self.$router.push("/warranty/list");
            }
        },
        updateWarranty (){
            var self = this;
            var id =  self.$route.params.id;

            self.$router.push("/warranty/edit/"+id);
        },
        addAsset (){
            var self = this;
            var id =  self.$route.params.id;

            self.$router.push("/asset-warranty/list/"+id+'?wo='+self.$route.params.id);
        },
        updateLimitation (){
            var self = this;
            var id =  self.$route.params.id;

            self.$router.push("/warranty-limitation/"+id+'?wo='+self.$route.params.id);
        },
        loadWarrantyData(){
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/warranty/view/" + segments[3],
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    console.log(data);
                    if (data.status == "success") {
                        self.warranty_code = data.content.code;
                        self.warranty_desc = data.content.description;
                        self.warranty_type = data.content.wtValue + " | " + data.content.wtName;
                        self.starting_point_value = data.content.starting_point_value;
                        self.period = data.content.period;
                        self.period_type = data.content.period_type;
                        self.miles = data.content.miles;
                        self.asset_warranty_arr = data.content.asset_warranty;
                        self.warranty_limit_arr = data.content.warranty_limit;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'warranty-view')
                }
            });
        },
        getActivityLog(){
          var self = this;
          self.activetab = 4;
          var path = window.location.pathname;
          var segments = path.split("/");
          if(!self.tabMenuArray.includes(self.activetab)){

            this.$root.$emit('activity_log_opted','warranty',segments[3]);
            self.activityLogsTabValue = "loadList";   // flag value set to loadList so that filters in list work properly.
          }
        },
    }

}
</script>



// WEBPACK FOOTER //
// src/components/WarrantyView.vue